import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { getCurrentWebhookSelector, getMsisdnsForWebhooksSelector, getWebhookTypesSelector } from 'app/webhooks/webhooks.reducer';
import { Router } from '@angular/router';
import { SaveWebhookAction, UpdateWebhookAction } from 'app/webhooks/webhooks.actions';
import updateFormGroupFromJson from 'app/shared/utils/updateFormGroupFromJson';
import { markFormAsTouched } from 'app/lead-generation/shared/reactive-forms/forEachElementInForm';
import { TranslateService } from '@ngx-translate/core';
var WebhookFormComponent = /** @class */ (function () {
    function WebhookFormComponent(fb, store, router, translate) {
        this.fb = fb;
        this.store = store;
        this.router = router;
        this.translate = translate;
    }
    WebhookFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.webhookForm = this.fb.group({
            subjectType: this.fb.control('PROJECT'),
            entityId: this.fb.control(''),
            types: this.fb.control([], [Validators.required]),
            name: this.fb.control('', [Validators.required]),
            endpoint: this.fb.control('', [Validators.required, Validators.pattern(/.*?\..{2,}/)]),
            active: this.fb.control(true)
        });
        this.store.select(getWebhookTypesSelector).subscribe(function (types) {
            _this.allEventTypes = types;
            _this.refreshEventTypesToSelect();
        });
        this.store.select(getCurrentWebhookSelector).subscribe(function (curr) {
            if (curr) {
                _this.handleExistingWebhook(curr);
            }
        });
        this.msisdns$ = this.store.select(getMsisdnsForWebhooksSelector);
    };
    Object.defineProperty(WebhookFormComponent.prototype, "selectedType", {
        get: function () {
            return this.webhookForm.get('subjectType').value;
        },
        enumerable: true,
        configurable: true
    });
    WebhookFormComponent.prototype.canSelectMsisdn = function () {
        return this.selectedType === 'MSISDN';
    };
    WebhookFormComponent.prototype.multipleSubjectTypesAvailable = function () {
        // currently, in Channels, we've got only one type of webhooks (per project = global)
        return false;
    };
    WebhookFormComponent.prototype.changeType = function () {
        this.webhookForm.get('types').setValue([]);
        this.refreshEventTypesToSelect();
    };
    WebhookFormComponent.prototype.save = function ($event) {
        $event.preventDefault();
        if (this.webhookForm.invalid) {
            markFormAsTouched(this.webhookForm);
            return;
        }
        var webhook = this.webhookForm.getRawValue();
        this.store.dispatch(this.existingId ? new UpdateWebhookAction({ id: this.existingId, webhook: webhook }) : new SaveWebhookAction(webhook));
    };
    WebhookFormComponent.prototype.cancel = function () {
        this.router.navigateByUrl('/webhooks/list');
    };
    WebhookFormComponent.prototype.refreshEventTypesToSelect = function () {
        var _this = this;
        this.eventTypesToSelect = this.allEventTypes
            .filter(function (type) { return type.subjectType === _this.selectedType; })
            .map(function (type) { return ({
            value: type.name,
            name: _this.translate.instant("WEBHOOKS.TYPES." + type.name)
        }); })
            .sort(function (a, b) { return a.name.localeCompare(b.name); });
    };
    WebhookFormComponent.prototype.handleExistingWebhook = function (webhook) {
        this.existingId = webhook.id;
        updateFormGroupFromJson(this.webhookForm, webhook);
        this.refreshEventTypesToSelect();
        var types = webhook.types.map(function (p) { return p.name; });
        this.webhookForm.get('types').setValue(types);
    };
    return WebhookFormComponent;
}());
export { WebhookFormComponent };
